import React from 'react'
import { Flex, Link } from '~/design_system'
import { useAccountMeQuery } from '~/api/accounts'
import { links } from '~/common/links'

export function WorkdayVndlyLogo(props: React.ImgHTMLAttributes<HTMLImageElement>) {
  return (
    <picture>
      <source
        srcSet="/static/images/logo-workday-vndly.png 1x, /static/images/logo-workday-vndly@2x.png 2x"
        type="image/png"
      />
      <img
        src="/static/images/logo-workday-vndly.png"
        alt="Workday VNDLY Logo"
        id="workday-vndly-logo"
        // render it at 50% of its original size
        width="236"
        height="60"
        {...props}
      />
    </picture>
  )
}

export function WorkdayVndlyLogoLink(props: React.ImgHTMLAttributes<HTMLImageElement> & { linkProps?: any }) {
  const { isCandidateRole, isLoading, isError } = useAccountMeQuery(undefined, { disableRedirects: true })
  let href = links.home.href
  if (!isLoading && isCandidateRole) {
    href = links.candidateTimesheets.href
  }
  const logo = <WorkdayVndlyLogo {...props} />
  if (isError) {
    return <Flex alignItems="center">{logo}</Flex>
  }

  return (
    <Link
      href={href}
      data-testid="footer-vndly-logo"
      display="flex"
      alignItems="center"
      _hover={{ bg: 'soap300' }}
      borderRadius={4}
      {...(props.linkProps || {})}>
      {logo}
    </Link>
  )
}
